import axios from 'axios';

const endpoint = '/notifications';
const entity = 'notification';
const key = 'id';

const state = {
  data: {},
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
};

const actions = {
  get({ commit }, params = '') {
    return new Promise((resolve, reject) => {
      axios.get(`${endpoint}${params}`)
        .then(({ data }) => {
          commit('data', data);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  find({}, options) {
    const {id, params = ''} = options;
    const base = `${endpoint}/${id}`;
    const url = (params) ? `${base}?${params}` : base;
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },
  post({ dispatch }, body = {}) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpoint}`, body)
        .then(({ data }) => {
          dispatch('get', '?populate[0]=createdBy&$populate[1]=viewedBy&$sort[createdAt]=-1')
            .then(() => resolve({ creating: true, entity, key, data }))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
  patch({ dispatch }, { id, body = {}}) {
    return new Promise((resolve, reject) => {
      if (!id) reject();
      axios.patch(`${endpoint}/${id}`, body)
        .then(({ data }) => {
          dispatch('get')
            .then(() => resolve({ creating: false, entity, key, data }))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
};

const getters = {
  data: state => state.data,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
